'use client';

import Image from 'next/image';
import Link from 'next/link';
import logo from '../../assets/logo.svg';
import { UI } from '../../lib/constants';

type Mode = 'login' | 'register';

export function AuthHeader({ mode }: { mode: Mode }) {
  return (
    <>
      <div className="mb-10 flex flex-col items-center gap-2">
        <Link href="/home" className="flex flex-col items-center gap-2">
          <Image src={logo} alt="Apporb" width={48} height={48} className="rounded-2xl" />
          <span className="text-sm font-semibold tracking-widest uppercase" style={{ color: 'var(--color-primary)' }}>
            {UI.appName}
          </span>
        </Link>
      </div>
      <div className="text-center mb-8">
        <h1 className="text-4xl font-light text-gray-800" style={{ fontFamily: 'Georgia, serif' }}>
          {mode === 'login' ? 'Sign in' : 'Create account'}
        </h1>
        <p className="text-sm text-gray-400 mt-2">
          {mode === 'login' ? 'Welcome back!' : 'Start growing your apps today.'}
        </p>
      </div>
    </>
  );
}
